import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router';

import { useInterviewContext } from '@/features/common/contexts/interview.context';
import ProceedToPaymentScreen from '@/features/register/pages/ProceedToPaymentScreen';
import { useBooth } from '@/features/settings/hooks/useBooth';

export default function ProceedToPaymentPage() {
  const navigate = useNavigate();
  const { createAndSetInterview } = useInterviewContext();
  const { booth, loading: boothLoading, isBooth } = useBooth();

  const handlePaymentSuccess = useCallback(
    async (paymentIntentId: string) => {
      try {
        const newInterview = await createAndSetInterview(paymentIntentId);
        if (newInterview) navigate('/interview', { replace: true });
      } catch {
        // Error already logged in context
      }
    },
    [createAndSetInterview, navigate],
  );

  const handleSkipPayment = useCallback(async () => {
    try {
      const newInterview = await createAndSetInterview();
      if (newInterview) navigate('/interview', { replace: true });
    } catch {
      // Error already logged in context
    }
  }, [createAndSetInterview, navigate]);

  const handleBack = useCallback(() => {
    navigate('/payment', { replace: true });
  }, [navigate]);

  useEffect(() => {
    if (!boothLoading && !(isBooth && booth?.terminalId)) {
      void handleSkipPayment();
    }
  }, [boothLoading, isBooth, booth?.terminalId, handleSkipPayment]);

  if (boothLoading) return null;
  if (!isBooth || !booth?.terminalId) return null;

  return <ProceedToPaymentScreen onValidate={handlePaymentSuccess} onBack={handleBack} />;
}
